import React from 'react';

interface QuoteCardProps {
    text: string;
    attribution?: string;
    className?: string;
}

export const QuoteCard: React.FC<QuoteCardProps> = ({
    text,
    attribution,
    className = '',
}) => {
    return (
        <blockquote className={`intellectual-quote ${className}`}>
            <p className="intellectual-quote-text">"{text}"</p>
            {attribution && (
                <footer className="intellectual-quote-attribution">
                    — {attribution}
                </footer>
            )}
        </blockquote>
    );
};

export default QuoteCard;
